import React, { useEffect, useState } from 'react'
import { ReactComponent as BG } from '../svgs/wallet-bg.svg'
import AccountDetails from '../atoms/AccountDetails'
import CustomTable from '../organisms/CustomTable'
import WalletCard from '../atoms/WalletCard'
import AddMoneyDialog from '../molecules/WalletDialogs/AddMoneyDialog'
import WithdrawMoneyDialog from '../molecules/WalletDialogs/WithdrawMoneyDialog'
import Badge from '../atoms/Badge'
import AddBankAccount from '../organisms/AddBankAccount'
import { Skeleton } from 'antd'
import getSymbolFromCurrency from 'currency-symbol-map'
import Button from '../atoms/Button'
import UploadIcon from '../svgs/upload.svg'
import UploadFiles from '../molecules/WalletDialogs/UploadFiles'
import { formatBalance } from '../../utils/helper/wallet'
import Pagination from '../atoms/Pagination'
import useWallet from '../../hooks/useWallet'
import useBank from '../../hooks/useBank'
import { getTransactions } from '../../utils/API/getTransactions'
import { useSearchParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import SelectWithdrawAccount from '../molecules/WalletDialogs/SelectWithdrawAccount'
import WithdrawConfim from '../molecules/WalletDialogs/WithdrawConfim'
import RemarksDailogBox from '../atoms/WalletRemarksDialogBox'

const headerData = [
  'Order ID',
  'Amount',
  'Date',
  'Type',
  'Reference no.',
  'Status',
  'Documents'
]

const WalletPage = () => {
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()

  const [addAccount, setAddAccount] = useState(false)
  const [addMoneyState, setAddMoneyState] = useState(false)
  const [withdrawMoneyState, setWithdrawState] = useState(false)
  const [uploadDoc, setUploadDoc] = useState(false)
  const [selectedTransaction, setSelectedTransaction] = useState(null)
  const [withdrawAmount, setWithdrawAmount] = useState(0)
  const [selectWithdrawAccount, setSelectWithdrawAccount] = useState(false)

  const [transactions, setTransactions] = useState([])
  const [transactionIds, setTransactionIds] = useState([])

  const [withdrawConfirm, setWithdrawConfirm] = useState(false)
  const [walletLoading, walletDetails, setWalletDetails] = useWallet()
  const [accountLoading, accountDetails, setAccountDetails] = useBank()

  const [pagination, setPagination] = useState({
    totalItems: 1,
    totalPages: 1,
    pageSize: 10
  })

  const currentPage = Number(searchParams.get('page')) || 1

  const [loading, setLoading] = useState(false)

  const [remarksData, setRemarksData] = useState('')
  const [remarksPopup, setRemarksPopup] = useState(false)

  const getData = async () => {
    try {
      setLoading(true)
      const { docs, totalDocs, totalPages, limit } = await getTransactions(
        `?page=${currentPage}&limit=${pagination.pageSize}`,
        dispatch
      )
      if (currentPage > totalPages) {
        setSearchParams({ page: totalPages })
      }
      setPagination(() => {
        return { totalItems: totalDocs, totalPages, pageSize: limit }
      })

      setTransactionIds(docs.map(({ _id }) => _id))

      setTransactions(
        docs.map(
          (
            {
              order_id,
              currency,
              requested_amount,
              createdAt,
              transaction_type,
              _id,
              status,
              remarks
            },
            index
          ) => {
            const date = new Date(createdAt)
            const disable = !(
              transaction_type?.toLowerCase() === 'deposit' &&
              status?.toLowerCase() === 'requested'
            )

            const hasRemarks = remarks.trim() !== ''

            return [
              order_id,
              <p>
                {"$"}{' '}
                {formatBalance(requested_amount)}
              </p>,
              date.toLocaleDateString().replaceAll('/', '-'),
              transaction_type,
              _id,
              <Badge varient={status}>
                <p className='w-32 py-px'>{status}</p>
              </Badge>,
              hasRemarks ? (
                <Button
                  onClick={() => {
                    setSelectedTransaction(index)
                    setRemarksData(remarks)
                    setRemarksPopup(true)
                  }}
                  varient={'secondary'}
                  className={
                    ' flex bg-red-100 text-red-700 items-center gap-x-2 justify-center py-1.5 text-xs font-normal w-24'
                  }
                >
                  Remarks
                </Button>
              ) : (
                <Button
                  disabled={disable}
                  onClick={() => {
                    setSelectedTransaction(index)
                    setUploadDoc(true)
                  }}
                  varient={'secondary'}
                  color={disable ? 'gray' : 'blue'}
                  className={
                    'text-white flex items-center gap-x-2 justify-center py-1.5 text-xs font-normal w-24'
                  }
                >
                  <img src={UploadIcon} className='w-3' alt='upload-icon' />
                  Upload
                </Button>
              )
            ]
          }
        )
      )
    } catch (error) {
      toast.error(error.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [currentPage])

  return (
    <>
      <AddMoneyDialog
        open={addMoneyState}
        onCancel={() => setAddMoneyState(false)}
        onAdd={() => setAddMoneyState(false)}
        balance={walletDetails.balance}
        currency={walletDetails.currency}
        updateData={getData}
        setWalletDetails={setWalletDetails}
      />
      <SelectWithdrawAccount
        open={selectWithdrawAccount}
        onCancel={() => {
          setSelectWithdrawAccount(false)
          setWithdrawAmount(0)
        }}
        setWithdrawConfirm={setWithdrawConfirm}
        data={accountDetails}
        withdrawAmount={withdrawAmount}
        setWalletDetails={setWalletDetails}
        updateData={getData}
      />
      <WithdrawMoneyDialog
        balance={walletDetails.balance}
        currency={walletDetails.currency}
        open={withdrawMoneyState}
        updateData={getData}
        onCancel={() => setWithdrawState(false)}
        onWithdraw={() => {
          setWithdrawState(false)
          setSelectWithdrawAccount(true)
        }}
        registerAmount={setWithdrawAmount}
      />

      <AddBankAccount
        open={addAccount}
        onSubmit={() => setAddAccount(false)}
        onCancel={() => setAddAccount(false)}
        setAccountDetails={setAccountDetails}
      />

      <WithdrawConfim
        open={withdrawConfirm}
        onCancel={() => setWithdrawConfirm(false)}
      />

      <UploadFiles
        open={uploadDoc}
        transactionId={transactionIds[selectedTransaction]}
        onCancel={() => {
          setSelectedTransaction(null)
          setUploadDoc(false)
        }}
        onSubmit={() => {
          setSelectedTransaction(null)
          setUploadDoc(false)
        }}
        updateData={getData}
      />

      <div className='bg-[#F4F6FA] h-full w-full p-6'>
        <div className='text-xl mb-4 tracking-[1.4px]'>
          Welcome to <b className='font-bold'>My Wallet</b>
        </div>
        <div className='w-full bg-white rounded-2xl shadow-formShadow flex p-6 justify-between'>
          {!walletLoading ? (
            <WalletCard
              walletData={walletDetails}
              onAdd={() => setAddMoneyState(true)}
              onWithdraw={() => setWithdrawState(true)}
              data={accountDetails}
            />
          ) : (
            <div className=' w-1/3'>
              <Skeleton.Button
                block={true}
                active={true}
                style={{ height: '15rem', width: '100%' }}
              />
            </div>
          )}

          {!accountLoading ? (
            <AccountDetails
              onAdd={() => setAddAccount(true)}
              data={accountDetails}
            />
          ) : (
            <div className=' w-1/3'>
              <Skeleton.Button
                block={true}
                active={true}
                style={{ height: '15rem', width: '100%' }}
              />
            </div>
          )}

          <BG />
        </div>

        <div className='text-xl tracking-[1.4px] mt-11 mb-2'>
          <b className='font-bold'>Transaction</b> history
        </div>

        <div className='w-full bg-white rounded-2xl shadow-formShadow pb-12 overflow-y-scroll no-scrollbar'>
          <div className='header p-4'>
            <div className='flex justify-between'>
              {/* <div className="border-2 rounded-lg mb-12 w-fit px-36">
                Seach-box
              </div> */}
            </div>
            <CustomTable
              headerData={headerData}
              data={loading ? [] : transactions}
            />

            {loading && (
              <div className='flex flex-col gap-y-4 p-4'>
                {Array.from({ length: 11 }).map((_, index) => (
                  <Skeleton.Button block={true} active={true} key={index} />
                ))}
              </div>
            )}
          </div>
          {pagination.totalPages > 1 && (
            <div className='flex justify-center mt-4 px-6'>
              <Pagination
                current={currentPage}
                total={pagination.totalItems}
                pageSize={pagination.pageSize}
                setCurrentPage={page => setSearchParams({ page })}
              />
            </div>
          )}
        </div>
        {remarksPopup && (
          <RemarksDailogBox
            open={remarksPopup}
            remarks={remarksData}
            onCancel={() => setRemarksPopup(false)}
          />
        )}
      </div>
    </>
  )
}

export default WalletPage
